import { render, staticRenderFns } from "./CalcRating.vue?vue&type=template&id=7da7c3fa&scoped=true&"
import script from "./CalcRating.vue?vue&type=script&lang=js&"
export * from "./CalcRating.vue?vue&type=script&lang=js&"
import style0 from "./CalcRating.vue?vue&type=style&index=0&id=7da7c3fa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da7c3fa",
  null
  
)

export default component.exports